<template>
  <div class="mapLine">
    <l-map ref="satelliteWishMap" @ready="mapReady" :maxBounds="maxBounds" :zoom="zoom" :center="center" :options="option">
      <l-tile-layer ref="mapLayer" :url="mapUrl" :options="mapSubdomains"/>
    </l-map>
  </div>
</template>

<script>
import L from 'leaflet'
import {LMap, LTileLayer} from 'vue2-leaflet';

// 导入图片
import markerIcon from '../../../../assets/SatelliteActivityBuyJpg/marker.png'

export default {
  components: {LMap, LTileLayer},
  data() {
    return {
      // 地图配置
      zoom: 12,
      center: L.latLng(36.2604541134187, 117.081861669118),
      maxBounds: L.latLngBounds([[85, -180], [-85, 180]]),
      // 禁用所有交互，包括拖动
      option: {
        zoomControl: false,
        attributionControl: false,
        renderer: L.canvas(),
        dragging: false,        // 禁用拖拽
        touchZoom: false,       // 禁用触摸缩放
        scrollWheelZoom: false, // 禁用滚轮缩放
        doubleClickZoom: false, // 禁用双击缩放
        boxZoom: false,         // 禁用框选缩放
        keyboard: false,        // 禁用键盘
        tap: false,             // 禁用点击
        touchZoomRotate: false, // 禁用触摸缩放旋转
      },
      mapUrl: 'https://t{s}.tianditu.gov.cn/DataServer?T=vec_w&X={x}&Y={y}&L={z}&tk=05861044e5fe4135647facbd39abc543',
      mapSubdomains: {subdomains: ['0', '1', '2', '3']},

      // 标记实例
      marker: null,
    }
  },
  methods: {
    mapReady() {
      console.log(123123)
      // 地图加载完成后的一些初始化操作
      this.$nextTick(() => {
        if (this.$refs.satelliteWishMap) {
          if (window['flutter_satelliteWishMapReady']) {
            window['flutter_satelliteWishMapReady'].postMessage('')
          }
        }
      });
    },

    /**
     * 添加标记
     * @param {number} lng - 经度
     * @param {number} lat - 纬度
     */
    addMarker(lng, lat) {
      console.log('添加标记到位置:', lng, lat);

      // 获取地图实例
      const map = this.$refs.satelliteWishMap.mapObject;
      if (!map) {
        console.error('地图未初始化');
        return;
      }

      // 清除之前的标记
      this.removeMarker();

      // 创建自定义图标
      const customIcon = L.icon({
        iconUrl: markerIcon,
        iconSize: [30, 30],
        iconAnchor: [15, 30],
      });

      // 添加标记到地图
      this.marker = L.marker([lat, lng], {icon: customIcon})
          .addTo(map);

      // 直接跳转，无动画
      map.setView([lat, lng], 16);
    },

    /**
     * 移除标记
     */
    removeMarker() {
      if (this.marker) {
        this.marker.remove();
        this.marker = null;
        console.log('标记已移除');
      }
    },
  },
  mounted() {
    window.satelliteWishMap = this
  },
  beforeDestroy() {
    this.removeMarker()
  }
}
</script>

<style scoped>
.mapLine {
  width: 100%;
  height: 108px;
}
</style>